export default "__VITE_ASSET__DIs3pnHc__"